module.exports = __webpack_public_path__ + "img/kid-item4.aaec0c04.png";